module.exports = __webpack_public_path__ + "media/entities/1801-c0fccfa1.png";